module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/wifi.svg?24fe740f4e1529800328dbfcd2e8ae9a";